import Vue from "vue";
import Vuex from "vuex";
import auth from "./store/auth";
import events from "./store/events";
import devices from "./store/devices";
import applications from "./store/applications";
import organizations from "./store/organizations";
import ownerships from "./store/ownerships";
import deployments from "./store/deployments";
import settings from "./store/settings";
import users from "./store/users";

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    auth,
    events,
    devices,
    applications,
    organizations,
    ownerships,
    deployments,
    settings,
    users,
  },
});
